import type {
  Body,
  Brand,
  ContractDetails,
  DeliveryDates,
  Equipment,
  Garage,
  GarageChain,
  Gearbox,
  Generation,
  Key,
  Motorization,
  Network,
  Organization,
  PhoneInput,
  Place,
  PremiumService,
  RentalCar,
  Service,
  Slot,
} from "@App/types";
import { ActionType } from "@App/state/action-types";
import type { Dispatch } from "redux";
import type { Action } from "@App/state/actions";

export {
  dismissModal,
  changeDatesFilter,
  changeDistanceFilter,
  changeNameFilter,
  changeSortByFilter,
  changeBrandFilter,
  changeBevSupportFilter,
  changeCommercialVehicleSupportFilter,
  changeBookableFilter,
  changeOnlyManufacturerFilter,
  changeShowAsNonBookable,
  setPresetFilter,
  setGarageProperties,
  setGarageTypeIds,
} from "@App/state/reducers/filters";

export const setNetwork = (network: Network | null) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.SET_NETWORK,
      payload: network,
    });
  };
};

export const chooseService = (service: Service | null) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.CHOOSE_SERVICE,
      payload: service,
    });
  };
};

export const chooseOrganization = (organization: Organization) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.CHOOSE_ORGANIZATION,
      payload: organization,
    });
  };
};

export const chooseBrand = (brand: Brand | null) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.CHOOSE_BRAND,
      payload: brand,
    });
  };
};

export const chooseGeneration = (generation: Generation | null) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.CHOOSE_GENERATION,
      payload: generation,
    });
  };
};

export const chooseMotorization = (motorization: Motorization | null) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.CHOOSE_MOTORIZATION,
      payload: motorization,
    });
  };
};

export const setKey = (key: Key) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.SET_KEY,
      payload: key,
    });
  };
};

export const chooseBody = (body: Body) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.CHOOSE_BODY,
      payload: body,
    });
  };
};

export const chooseGearbox = (gearbox: Gearbox) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.CHOOSE_GEARBOX,
      payload: gearbox,
    });
  };
};

export const setMileage = (mileage: number | null) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.SET_MILEAGE,
      payload: mileage,
    });
  };
};

export const setRegistrationDate = (registrationDate: Date | null) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.SET_REGISTRATION_DATE,
      payload: registrationDate ? registrationDate.toISOString() : null,
    });
  };
};

export const addEquipment = (equipment: Equipment) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.ADD_EQUIPMENT,
      payload: equipment,
    });
  };
};

export const removeEquipment = (equipment: Equipment) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.REMOVE_EQUIPMENT,
      payload: equipment,
    });
  };
};

export const chooseGarage = (garage: Garage) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.CHOOSE_GARAGE,
      payload: garage,
    });
  };
};

export const choosePlace = (place: Place | null) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.CHOOSE_PLACE,
      payload: place,
    });
  };
};

export const chooseSlot = (slot: Slot | null) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.CHOOSE_SLOT,
      payload: slot,
    });
  };
};

export const addPremiumService = (premiumService: PremiumService) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.ADD_PREMIUM_SERVICE,
      payload: premiumService,
    });
  };
};

export const removePremiumService = (premiumService: PremiumService) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.REMOVE_PREMIUM_SERVICE,
      payload: premiumService,
    });
  };
};

export const clearPremiumServices = () => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.CLEAR_PREMIUM_SERVICES,
      payload: [],
    });
  };
};

export const setFirstName = (firstName: string) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.SET_FIRST_NAME,
      payload: firstName,
    });
  };
};

export const setLastName = (lastName: string) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.SET_LAST_NAME,
      payload: lastName,
    });
  };
};

export const setEmail = (email: string) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.SET_EMAIL,
      payload: email,
    });
  };
};

export const setPhone = (phone: PhoneInput) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.SET_PHONE,
      payload: phone,
    });
  };
};

export const setNumberPlate = (numberPlate: string) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.SET_NUMBERPLATE,
      payload: numberPlate,
    });
  };
};

export const addSubRepair = (subRepair: string) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.ADD_SUB_REPAIR,
      payload: subRepair,
    });
  };
};

export const removeSubRepair = (subRepair: string) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.REMOVE_SUB_REPAIR,
      payload: subRepair,
    });
  };
};

export const setContractDetails = (contractDetails: ContractDetails) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.SET_CONTRACT_DETAILS,
      payload: contractDetails,
    });
  };
};

export const updateContractDetails = (contractDetails, updatedValues) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_CONTRACT_DETAILS,
      payload: Object.assign({}, contractDetails, updatedValues),
    });
  };
};

export const setDeliveryDates = (deliveryDates: DeliveryDates) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.SET_DELIVERY_DATES,
      payload: deliveryDates,
    });
  };
};

export const changeGarageChain = (garageChains: GarageChain[]) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.SET_GARAGE_CHAINS,
      payload: garageChains,
    });
  };
};

export const setRentalCarSelection = (rentalCarSelection: RentalCar) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.SET_RENTAL_CAR_SELECTION,
      payload: rentalCarSelection,
    });
  };
};

export const setVIN = (vin: string) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.SET_VIN,
      payload: vin,
    });
  };
};

export const setHSNTSN = (hsntsn: string) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.SET_HSNTSN,
      payload: hsntsn,
    });
  };
};

export const setContractNumber = (contractNumber: string) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.SET_CONTRACT_NUMBER,
      payload: contractNumber,
    });
  };
};

export const setMessage = (message: string) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.SET_MESSAGE,
      payload: message,
    });
  };
};

export const setStreet = (street: string) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.SET_STREET,
      payload: street,
    });
  };
};

export const setCity = (city: string) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.SET_CITY,
      payload: city,
    });
  };
};

export const setPostcode = (postcode: string) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.SET_POSTCODE,
      payload: postcode,
    });
  };
};

export const setAddition = (addition: string) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.SET_ADDITION,
      payload: addition,
    });
  };
};

export const setUserConfirmedAddress = (confirmed: boolean) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.SET_USER_CONFIRMED_ADDRESS,
      payload: confirmed,
    });
  };
};

export const setMustUseAuthorizedGarage = (mustUseAuthorizedGarage: boolean) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.SET_MUST_USE_AUTHORIZED_GARAGE,
      payload: mustUseAuthorizedGarage,
    });
  };
};

export const setClaimNumber = (claimNumber: string) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.SET_CLAIM_NUMBER,
      payload: claimNumber,
    });
  };
};

export const setReviewOptIn = (reviewOptIn: boolean) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.SET_REVIEW_OPT_IN,
      payload: reviewOptIn,
    });
  };
};

export * from "@App/state/action-creators/filter";
